import { FormattedMessage } from 'react-intl';
import React from 'react';
import { Chip } from '@mui/material';
import type { EventSourceEnum } from 'app/types';

interface EventSourceChipProps {
  value: EventSourceEnum;
}

const EventSourceChip: React.FC<EventSourceChipProps> = ({ value }) => {
  const styleMap = {
    user: {
      color: '#1976D2',
      backgroundColor: '#E3F2FD',
    },
    salary_package: {
      color: '#388E3C',
      backgroundColor: '#E8F5E8',
    },
    salary_table: {
      color: '#ff5e5e',
      backgroundColor: '#f5e8ea',
    },
    insurer_data: {
      color: '#6A1B9A',
      backgroundColor: '#F3E5F5',
    },
    system: {
      color: '#0097A7',
      backgroundColor: '#E0F2F1',
    },
    system_new_year: {
      color: '#F57C00',
      backgroundColor: '#FFF3E0',
    },
    unknown: {
      color: '#616161',
      backgroundColor: '#F5F5F5',
    },
  };

  if (!value) {
    return null;
  }

  return <Chip sx={styleMap[value] || {}} label={<FormattedMessage id={`events.content.eventSource.${value}`} />} />;
};

export default EventSourceChip;
